module.exports = ".info span {\n  background-color: black;\n  color: white;\n  height: 100%;\n  direction: rtl; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/info/info.component.scss
// module id = ./src/app/info/info.component.scss
// module chunks = main